import { IsNotEmpty } from 'class-validator';

export class SimpleValueDto<T = any> {
  @IsNotEmpty()
  data: T;
}